import React, { useState, useEffect, useContext } from 'react';
import Close from '../../Reutilizaveis/CloseButton';
import ArrowUpDown from '../../../assets/unfold_more_black_24dp.svg';
import { ReactSVG } from 'react-svg';

import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';

import './styles.scss';

const DropDown = ({
  itens,
  idDropDown,
  setValue,
  label,
  nomeDropDown,
  obrigatorio,
  error,
  altura,
  overflow,
  alturaMinima,
  resetApontamentoMotivo,
  setResetApontamentoMotivo,
  widthMeuImovel,
  marginLeftMeuImovel,
  desabilitado,
  nomeSelecionado,
  btnClose,
  renegociacao,
  renegociacaoWidth,
  marginTop,
  marginBottom,
}) => {
  const [nomeSolicitacao, setNomeSolicitacao] = useState('');

  const { tema } = useContext(ContextoListaApartamentos);

  useEffect(() => {
    if (resetApontamentoMotivo) {
      setValue('');
      setNomeSolicitacao('');
      setResetApontamentoMotivo(false);
    }
  }, [resetApontamentoMotivo]);

  useEffect(() => {
    if (nomeSelecionado != undefined) setNomeSolicitacao(nomeSelecionado);
  }, [nomeSelecionado]);

  useEffect(() => {
    if (itens?.length === 1) {
      setNomeSolicitacao(itens[0]?.nome);
      setValue(itens[0]?.nome);
    }
  }, [itens]);

  function showOptions(e) {
    e.preventDefault();
    if (!desabilitado) {
      let itens = document.getElementById(idDropDown);
      itens.classList.toggle('show');
    }
  }

  window.onclick = function (event) {
    if (
      !event.target.matches('.DropDownBtn') &&
      !event.target.matches('.dropDownIten')
    ) {
      let dropdowns = document.getElementsByClassName('dropdown-content');
      let i;
      for (i = 0; i < dropdowns.length; i++) {
        let openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  };

  let estiloPersonalizado = {};

  let estiloRenegociacao = {};

  if (renegociacao) {
    estiloPersonalizado = {
      border: 0,
      width: '100%',
      margin: 0,
      paddingLeft: 0,
    };
    estiloRenegociacao = {
      width: `${renegociacaoWidth}px`,
      left: '-40px',
    };
  } else if (desabilitado == true) {
    estiloPersonalizado = {
      border: error ? '2px solid #B61817' : '',
      height: altura,
      width: widthMeuImovel,
      marginLeft: marginLeftMeuImovel,
      backgroundColor: '#d1d1d1',
      cursor: 'not-allowed',
      opacity: '0.5',
      marginTop,
      marginBottom,
    };
  } else {
    estiloPersonalizado = {
      border: error ? '2px solid #B61817' : '',
      height: altura,
      width: widthMeuImovel,
      marginLeft: marginLeftMeuImovel,
      marginTop,
      marginBottom,
    };
  }

  return (
    <div
      className={`dropDownFiltro ${!desabilitado ? 'active' : ''}`}
      style={estiloPersonalizado}
    >
      <span
        id={'btn' + idDropDown}
        className='dropDownFiltro__name centralized DropDownBtn'
        onClick={(e) => {
          showOptions(e);
        }}
      >
        {nomeSolicitacao === '' ? (
          <span
            className='DropDownBtn'
            style={renegociacao && { color: '#4d4d4d' }}
          >
            {nomeDropDown}
          </span>
        ) : (
          <span
            className='DropDownBtn'
            style={renegociacao && { color: tema.primaryColor }}
          >
            {nomeSolicitacao}
          </span>
        )}
      </span>
      <ReactSVG
        src={ArrowUpDown}
        beforeInjection={(svg) => {
          svg.classList.add('DropDownBtn');
          svg.classList.add('arrowDropDown');
        }}
        onClick={(e) => {
          showOptions(e);
        }}
      />

      <label>{label}</label>

      <div
        className='dropDownFiltro__itens dropdown-content'
        id={idDropDown}
        style={renegociacao && estiloRenegociacao}
      >
        {btnClose == undefined && (
          <span
            onClick={() => {
              setNomeSolicitacao('');
              setValue('');
            }}
            className='dropDownFiltro__itens__cancel'
          >
            <Close tamanho='20px' tamanhoIcone='15px' />
          </span>
        )}
        <ul
          style={{
            minHeight: alturaMinima != undefined ? alturaMinima : '',
            height: alturaMinima != undefined ? altura : '370px',
            overflowY: overflow != undefined ? overflow : 'scroll',
            overflowX: 'hidden',
          }}
        >
          {itens?.length === 1 && <li key={itens[0].nome}>{itens[0].nome}</li>}
          {itens?.length > 1 &&
            itens.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setNomeSolicitacao(item.nome);
                  setValue(item.nome);
                }}
              >
                {item.nome}
              </li>
            ))}
        </ul>
      </div>
      {obrigatorio && (
        <label className='dropDownFiltro__labelObrigatorio'>
          Campo obrigatório*
        </label>
      )}
    </div>
  );
};

export default DropDown;
